import { axiosEduServer } from "../utils/configAxios";

export const crearDia = (data) => {
  return axiosEduServer.post('/dia', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarDia = (id, data) => {
  return axiosEduServer.put(`/dia/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarDia = (id) => {
  return axiosEduServer.delete(`/dia/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneDia = (id) => {
  return axiosEduServer.get(`/dia/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllDias = () => {
  return axiosEduServer.get('/dia').then(({ data }) => data).catch((err) => { throw err });
};